import { useEffect } from 'react';

/**
 * Custom hook to warn user about unsaved changes
 * @param {boolean} hasUnsavedChanges - Whether there are unsaved changes
 * @param {Function} onBeforeUnload - Optional callback before page unload
 */
export const useUnsavedChangesWarning = (hasUnsavedChanges, onBeforeUnload) => {
  // Warn on page refresh/close
  useEffect(() => {
    if (!hasUnsavedChanges) return;

    const handleBeforeUnload = (e) => {
      if (onBeforeUnload) {
        onBeforeUnload();
      }
      e.preventDefault();
      e.returnValue = 'You have unsaved changes. Are you sure you want to leave?';
      return e.returnValue;
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, [hasUnsavedChanges, onBeforeUnload]);
};

